import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.deseaseOutbreak.loading;
export const deseaseOutbreakErrorMessage = (state: RootState) =>
  state.deseaseOutbreak.error;
export const deseaseOutbreakDataResponse = (state: RootState) =>
  state.deseaseOutbreak.deseaseOutbreakResponse;
